import { Stack } from '@mui/material';
import { FragmentMediaFiles } from './media/FragmentMediaFiles';
import { FragmentSubtitlesFiles } from './subtitle-status/FragmentSubtitlesFiles';

export function FragmentFilesView() {
  return (
    <Stack spacing={3}>
      <FragmentMediaFiles />
      <FragmentSubtitlesFiles />
    </Stack>
  );
}
